import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EPromoCodeSortField,
  IPromoCode,
  PPromoCodeFilter,
} from "src/core/promoCode/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IPromoCodeState {
  promoCodes: IPromoCode[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IPromoCodeState = {
  promoCodes: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "promo-code/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "promo-code/FETCH_SUCCEEDED";
const FETCH_FAILED = "promo-code/FETCH_FAILED";
const POLLING_START_REQUESTED = "promo-code/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "promo-code/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IPromoCode[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PPromoCodeFilter;
    pagination: IPagination;
    sorts: ISort<EPromoCodeSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IPromoCodeState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IPromoCodeState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.promoCodes = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
